import { Component, OnInit } from '@angular/core';
import { GeneralSettingsService } from '../../Services/general-settings.service';

@Component({
  selector: 'app-member-faq',
  template: require('./member-faq.component.html'),
  styles: [require('./member-faq.component.css')]
})
export class MemberFaqComponent implements OnInit {
  subscriptionFee:string= "";
  generalEmail:string = "";

  constructor(private generalSettingsService:GeneralSettingsService) { }

  ngOnInit() {
    this.generalSettingsService.getSubscriptionFee().subscribe( (res:any)=>{
      if (res.status == 200){
        this.subscriptionFee = res.value.subscriptionFee;
      }
    })

    this.generalSettingsService.getGeneralEmail().subscribe( (res:any)=>{
      if (res.status == 200){
        this.generalEmail = res.value.generalEmail;
      }
    })
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/member-faq/member-faq.component.ts